import { translate } from 'react-i18next';
import { compose, hoistStatics, withState, withHandlers, defaultProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import DocumentFilter from './DocumentFilter';
import DocumentService from '../../../services/document.service';


const defaultDate = {
  startDate: new Date(),
  endDate: new Date(),
  key: 'selection',
};


const handleSelect = props => ({ selection }) => {
  const { setSelectionRange, setDateChanged } = props;
  setSelectionRange({
    startDate: selection.startDate,
    endDate: selection.endDate,
    key: selection.key,
  });
  setDateChanged(true);
};


const defaultFilters = (props) => {
  const filterObj = DocumentService.getExtList(props.t);
  Object.keys(filterObj).forEach((item) => {
    filterObj[item] = false;
  });
  return filterObj;
};

const changeFilter = props => async (e, value) => {
  e.preventDefault();
  const { setFilters, filters } = props;
  let newFilters = { ...filters };
  if (value === DocumentService.TYPE_OTHER && !filters.other) {
    Object.keys(newFilters).forEach((item) => {
      newFilters[item] = false;
    });
  } else {
    newFilters.other = false;
  }
  newFilters = { ...newFilters, [value]: !filters[value] };
  setFilters(newFilters);
};


const toggleFilters = props => (e) => {
  e.preventDefault();
  const { showFilters, setShowFilters } = props;
  setShowFilters(!showFilters);
};

const applyFilters = props => (e) => {
  e.preventDefault();
  const { callbackToChangeFilter, filters, selectionRange, dateChanged } = props;
  let filtersToApply = Object.keys(filters).filter(f => filters[f]);
  if (filtersToApply.length === Object.keys(filters).length) filtersToApply = [];
  const dates = dateChanged ? [{ name: 'startDate', value: moment(selectionRange.startDate).format('YYYY-MM-DD') },
    { name: 'endDate', value: moment(selectionRange.endDate).format('YYYY-MM-DD') }] : [];
  callbackToChangeFilter([{ name: 'type', value: filtersToApply },
    ...dates]);
};

const resetFilter = props => (e) => {
  e.preventDefault();
  const { callbackToResetFilter, setFilters, setDateChanged, setSelectionRange } = props;
  callbackToResetFilter();
  setSelectionRange(defaultDate);
  setFilters(defaultFilters(props));
  setDateChanged(false);
};

const enhance = compose(
  translate('portal'),
  withState('showFilters', 'setShowFilters', false),
  withState('filters', 'setFilters', props => defaultFilters(props)),
  withState('selectionRange', 'setSelectionRange', defaultDate),
  withState('dateChanged', 'setDateChanged', false),
  defaultProps({
    statusList: DocumentService.getExtList,
  }),
  withHandlers({
    handleSelect,
    toggleFilters,
    changeFilter,
    applyFilters,
    resetFilter,
  }),
);

export default withRouter(hoistStatics(enhance)(DocumentFilter));



// WEBPACK FOOTER //
// ./src/components/modules/documentFilter/index.js